import React from 'react';
import PropTypes from 'prop-types';
import {Dialogue, Button, Modal} from '@albert-io/atomic';
import {rejectUser} from 'client/SchoolAdministration/School/ManageStaff/Staff/manageStaffUtils';

const RejectUserModal = ({params, staffMemberToReject, setStaffMemberToReject}) => {
  return (
    <Modal handleClose={() => setStaffMemberToReject(null)}>
      {({modalContentStyle}) => (
        <Dialogue
          className={modalContentStyle}
          inModal
          title='Reject User'
          hideCloseBtn
          alignTitle='center'
        >
          <Dialogue.Body align='center'>
            <p>
              Are you sure you want to reject
              <strong> {staffMemberToReject.getTeacher().getFullName()}</strong>?
            </p>
          </Dialogue.Body>
          <Dialogue.BtnGroup align='right' className='u-display_inline'>
            <Button color='secondary' onClick={() => setStaffMemberToReject(null)}>
              Cancel
            </Button>
            <Button
              color='destructive'
              onClick={() => {
                rejectUser({
                  staff: staffMemberToReject,
                  schoolId: params.schoolId
                });
                setStaffMemberToReject(null);
              }}
            >
              Reject
            </Button>
          </Dialogue.BtnGroup>
        </Dialogue>
      )}
    </Modal>
  );
};

RejectUserModal.propTypes = {
  setStaffMemberToReject: PropTypes.func,
  params: PropTypes.object,
  staffMemberToReject: PropTypes.object
};

export default RejectUserModal;
